import {useEventListener} from "@vueuse/core";
import {DRAG_POSITION} from "./dict";

let position = "";
let _type = "";
/**
 * 拖动交换list顺序
 * @eg: <i :data-index="index" data-dtype="test" v-swapListByDrag="list"></i>
 */
export const vSwapListByDrag = {
  mounted(el, {value}) {
    let target = el.dataset.target
    let targetEl = target ? el.querySelector(target) : ''
    if (targetEl) {
      targetEl.setAttribute("draggable", true);
      targetEl.classList.add("move");
    } else {
      el.setAttribute("draggable", true);
      el.classList.add("move");
    }
    useEventListener(el, "dragstart", (e) => {
      if (targetEl && !targetEl.contains(e.target)) {
        e.preventDefault()
      }
      let index = el.dataset.index;
      _type = el.dataset.dtype;
      if (!index) {
        throw new Error("data-index attribute was not found!");
      }
      e.dataTransfer.setData(
        "text/plain",
        JSON.stringify({
          index: Number(index),
        }),
      );
    });
    useEventListener(el, "dragover", (e) => {
      try {
        let targetType = el.dataset.dtype;
        if (targetType === _type) {
          let rect = el.getBoundingClientRect();
          let topDis = e.y - rect.top;
          let topRatio = topDis / rect.height;
          let color = el.dataset.color || '#3e7aff'
          // 上下为插入
          if (topRatio < 0.3) {
            el.style.borderBottom = "none";
            position = DRAG_POSITION.top;
            el.style.borderTop = `2px solid ${color}`;
          } else if (topRatio > 0.7) {
            el.style.borderTop = "none";
            position = DRAG_POSITION.bottom;
            el.style.borderBottom = `2px solid ${color}`;
          } else {
            clearBorder(el);
            // 这个为交换
            position = DRAG_POSITION.in;
          }
          e.preventDefault();
        }
      } catch (e) {
        console.log(e);
      }
    });
    useEventListener(el, "drop", (e) => {
      e.preventDefault();
      let data = JSON.parse(e.dataTransfer.getData("text/plain"));
      let i = data.index;
      let targetIndex = Number(el.dataset.index);
      let temp = value[targetIndex];
      let tempOrigin = value[i];
      // 前面插入
      if (position === DRAG_POSITION.top) {
        value.splice(i, 1);
        // 为什么要判断下原始索引和拖拽目标的索引再处理插入？思考一下
        if (i > targetIndex) {
          value.splice(targetIndex, 0, tempOrigin);
        } else {
          value.splice(targetIndex - 1, 0, tempOrigin);
        }
        // 	后面插入
      } else if (position === DRAG_POSITION.bottom) {
        value.splice(i, 1);
        if (i > targetIndex) {
          value.splice(targetIndex + 1, 0, tempOrigin);
        } else {
          value.splice(targetIndex, 0, tempOrigin);
        }
      } else {
        value[targetIndex] = value[i];
        value[i] = temp;
      }
      clearBorder(el);
    });
    useEventListener(el, "dragleave", (e) => {
      clearBorder(el);
    });
  },
};

function clearBorder(el) {
  el.style.borderTop = "none";
  el.style.borderBottom = "none";
}

export default {
  vSwapListByDrag,
};
